<section class="log-out text-center">
  <div class="wrapperAlert">
    <div class="contentAlert">
      <div class="topHalf">
        <img src="../../../../../../assets/images/svg-icons/h3.png">
        <h3 class="header-text">You have been successfully logout</h3>
        <h3>If you want to login again <br> Go back to <a class="anchor-text" href="{{teleUrl}}">Telecare</a>
        </h3>
      </div>
    </div>
  </div>

</section>
